import store from '@/store';

export class AuthenticationService {
  public is(...roles: string[]) {
    let hasRole = false;
    for (const role of roles) {
      if (store.state.user.roles.includes(role)) {
        hasRole = true;
      }
    }
    return hasRole;
  }

  public isAdmin() {
    return store.state.user.roles.includes('admin');
  }
  public isHr() {
    return store.state.user.roles.includes('hr');
  }

  public isLoggedUser(id: number) {
    return store.state.user.id === id || this.isAdmin();
  }

  public userId() {
    return store.state.user.id;
  }
}

export default new AuthenticationService();
